/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_TitleInputs */

const cs_deals_title = /** @type {(inputs: Deals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchody`)
};

const en_deals_title = /** @type {(inputs: Deals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deals`)
};

/**
* | output |
* | --- |
* | "Deals" |
*
* @param {Deals_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_title = /** @type {((inputs?: Deals_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_title(inputs)
	return cs_deals_title(inputs)
});